export default __webpack_public_path__ + "static/article-3-be7ac79c3ae189576a7dada9acf92734.png";